"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountsConfirmRemove = void 0;
const modal_form_component_1 = require("../../components/modal.form/modal.form.component");
const index_1 = require("../../i18n/index");
const ACCOUNTS_REMOVE_SUCCESS = { key: index_1.T.ACCOUNTS_REMOVE_SUCCESS };
class AccountsConfirmRemove extends modal_form_component_1.ModalFormComponent {
    constructor(ctrl, user) {
        super({
            title: index_1.T.ACCOUNTS_REMOVE_TITLE,
            confirm: index_1.T.ACCOUNTS_REMOVE,
            success: ACCOUNTS_REMOVE_SUCCESS,
        });
        this.ctrl = ctrl;
        this.user = user;
    }
    get nodes() {
        return (0, index_1.Translate)(index_1.T.ACCOUNTS_REMOVE_CONFIRM, this.user.username);
    }
    submit() {
        return this.ctrl.removeUser(this.user);
    }
    failToChange() {
        this.ctrl.setLoading(this.user.objectId, false);
    }
}
exports.AccountsConfirmRemove = AccountsConfirmRemove;
//# sourceMappingURL=accounts.confirm.remove.js.map